import React, { useContext, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";

import AppContext from "../../contexts/AppContext";
import routes from "../../constants/Routes";
import { playAudio } from "../../utils/Utils";
import CONSTANT from "../../constants/Constant";

import MainHeaderWrapper from "../shared/layout/HeadWrappers/MainHeaderWrapper";
import Footer from "../shared/layout/Footer";
import MyAssessmentsDetail from "./MyAssessmentsDetail";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";
import RemoteAssistanceSection from "../remote-assistance/RemoteAssistanceSection";

const MyAssessments = () => {
    const { userInfo } = useContext(AppContext);
    const { EnableFysicalScore, IsPostureAnalyzeEnabled } = userInfo.Permissions;
    const { isShowCompletedAssessments } = useParams();

    useEffect(() => {
        playAudio('remove').then();
    }, []);

    return (
        <>
            {!EnableFysicalScore && !IsPostureAnalyzeEnabled && (
                <Redirect to={`${routes.landing}`}/>
            )}
            {(EnableFysicalScore || IsPostureAnalyzeEnabled) && (
                <>
                    {/*<MobileHeader/>*/}
                    <MainHeaderWrapper/>
                    {!EnableFysicalScore && IsPostureAnalyzeEnabled && (
                        <>
                            <RemoteAssistanceSection />
                            <MyAssessmentsDetail
                                showCompletedAssessments={JSON.parse(isShowCompletedAssessments)}/>
                        </>
                    )}
                    {EnableFysicalScore && (
                        <>
                            <BodyWithTopMenu pageName={CONSTANT.PAGE_NAME.MY_ASSESSMENTS}>
                                <RemoteAssistanceSection />
                                <MyAssessmentsDetail
                                    showCompletedAssessments={JSON.parse(isShowCompletedAssessments)}/>
                            </BodyWithTopMenu>
                            <Footer/>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default MyAssessments;
